<template lang="pug">
#nav
  .container-fluid
    .row
      transition(name="fade")
        .icon-home(
          :class="{ 'icon-white': menuIsOpen || logoClr == 'white' }",
          :to="'/'",
          v-if="menuIsOpen || !showingDetail"
        )
          div(@click="logoClick")
            svg(:style="{ height: '50px' }") version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50.2 45.5" style="enable-background:new 0 0 50.2 45.5;" xml:space="preserve" <path d="M28.3,14.4c0-4.6,0-9.2,0-13.7c0-0.5,0.1-0.7,0.7-0.7c3.7,0,7.3,0,11,0c0.6,0,0.6,0.2,0.6,0.7c0,3,0,6.1,0,9.1	c0,0.5,0.1,0.6,0.6,0.6c2,0,3.9,0,5.9,0c0.4,0,0.5,0.1,0.5,0.5c0,3,0,6.1,0,9.1c0,0.4-0.1,0.5-0.5,0.5c-2,0-3.9,0-5.9,0	c-0.4,0-0.5,0.1-0.5,0.5c0,2.5,0,5,0,7.5c0,1,0.2,2,0.5,3c0.9,2.4,2.9,3.3,5.3,3.2c1.1-0.1,2.1-0.4,3.1-0.9c0.4-0.2,0.5-0.1,0.5,0.3	c0,3.6,0,7.1,0,10.7c0,0.3,0,0.5-0.4,0.5c-4.3-0.1-8.6-0.5-12.5-2.5c-4.4-2.2-7-5.8-8.1-10.6c-0.4-1.8-0.6-3.6-0.6-5.5	C28.3,22.7,28.3,18.5,28.3,14.4z"/><path d="M0.2,35.5c1.4,0.5,2.8,1,4.3,1c1.9,0,3.1-1,3.4-2.9C8,33,8.1,32.5,8.1,32c0-3.6,0-7.2,0-10.8c0-0.6-0.2-0.7-0.7-0.7	c-1.4,0-2.9,0-4.3,0c-0.4,0-0.5-0.1-0.5-0.5c0-3.1,0-6.1,0-9.2c0-0.4,0.1-0.5,0.5-0.5c1.5,0,3,0,4.5,0c0.5,0,0.6-0.1,0.6-0.6	c0-3,0-6.1,0-9.1C8.1,0.2,8.2,0,8.7,0c3.7,0,7.3,0,11,0c0.5,0,0.7,0.2,0.7,0.7c0,10.1,0,20.2,0,30.3c0,2.9-0.4,5.7-1.8,8.3	c-1.9,3.7-5.1,5.5-9.1,6c-1.9,0.2-3.7,0-5.6-0.4c-0.3-0.1-0.6-0.2-0.7-0.5c-1-2.9-2-5.7-3-8.6C0.2,35.6,0.2,35.6,0.2,35.5z"/>
          .backText(
            :style="{ color: menuIsOpen ? 'white' : menuClr }",
            @click="logoClick"
          ) {{ $t('backToHome') }}
      transition(name="fade")
        .navIcons-right(v-if="menuIsOpen || !showingDetail")
          .icon-menu(
            @click="clickMenu",
            :class="{ 'icon-white': menuIsOpen || menuClr == 'white' }"
          )
            font-awesome-icon(
              :icon="menuIsOpen ? 'times' : 'bars'",
              size="3x",
              :style="{ color: menuIsOpen ? 'white' : menuClr }"
            )
          .icon-lang(
            @click="setLocale",
            :class="{ 'icon-white': menuIsOpen || menuClr == 'white' }",
            :style="{ color: getLangClr()}",
            v-if="$route.path != '/game'"
          ) {{ $t('lang') }}
    .row
      transition(name="menu")
        #menu.menu-full.d-flex.flex-column.justify-content-between(
          v-if="menuIsOpen"
        )
          router-link.d-flex.justify-content-start.align-items-center.menu-link(
            v-for="(link, index) in links",
            :key="index",
            :to="link.to",
            @click.native="menuIsOpen = false",
            :class="index % 2 == 0 ? 'left' : 'right'"
          )
            .menu-link-zh {{ link[$i18n.locale == 'en' ? 'en' : 'zh'] }}
            .menu-link-en {{ link[$i18n.locale == 'en' ? 'zh' : 'en'] }}
            img.dashed-border(src="@/assets/images/dashed-border.svg")
    .row
      transition
        #menu.menu-side.d-flex.flex-column(
          :class="{ 'menu-side-open': menuIsOpen }"
        )
          router-link.d-flex.justify-content-start.align-items-center.menu-link(
            v-for="(link, index) in links",
            :key="index",
            :to="link.to",
            @click.native="clickLink",
            :class="index % 2 == 0 ? 'left' : 'right'"
          )
            .menu-link-zh {{ link[$i18n.locale == 'en' ? 'en' : 'zh'] }}
            // .menu-link-en {{ link[$i18n.locale == 'en' ? 'zh' : 'en'] }}
            img.dashed-border(src="@/assets/images/dashed-border.svg")
          // .filter-blur
</template>

<script>
import $ from "jquery";
import AOS from "aos";
export default {
  name: "Nav",
  props: {
    logoClr: {
      type: String,
      default: "black"
    },
    menuClr: {
      type: String,
      default: "black"
    },
    langClrLg: {
      type: String,
      default: "black"
    },
    langClrSm: {
      type: String,
      default: "white"
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      menuIsOpen: false,
      links: [
        {
          to: "/",
          zh: "首頁/智慧台北",
          en: "Smart Taipei"
        },
        {
          to: "/prevention",
          zh: "科技防疫",
          en: "Tech Against COVID-19"
        },
        {
          to: "/explore",
          zh: "發現台北",
          en: "Discover Taipei"
        },
        {
          to: "/events",
          zh: "系列活動",
          en: "Activities"
        },
        {
          to: "/about",
          zh: "關於我們",
          en: "About Us"
        }
      ]
    };
  },
  methods: {
    setLocale() {
      this.$i18n.locale = this.$i18n.locale == "zh" ? "en" : "zh";
      if (this.$route.path == "/prevention") {
        // console.log('aos refresh')
        setTimeout(() => AOS.refresh(), 500);
      }
    },
    route(to) {},
    logoClick() {
      this.$store.commit("setPageDelay", 300);
      this.$store.dispatch("triggerLoading", 1000);
      this.menuIsOpen = false;
      setTimeout(() => {
        this.$router.push("/").catch(() => {});
      }, 300);
    },
    clickMenu() {
      this.menuIsOpen = !this.menuIsOpen;
      if (this.windowWidth > 768) {
        $(".home").toggleClass("shift-home");
      }
    },
    clickLink() {
      this.menuIsOpen = false;
      $(".home").removeClass("shift-home");
    },
    getLangClr(){
      let langClr
      
      
      if(this.windowWidth > 768){
        langClr = this.langClrLg
      }else{
        langClr = this.menuIsOpen ? 'white' : this.langClrSm
      }
      console.log(langClr)

      return langClr
    }
  },
  computed: {
    showingDetail() {
      return this.$route.path == "/explore" && this.$store.state.showingDetail;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
  }
};
</script>

<style lang="sass">
@import "@/assets/css/mixins.scss"

.home
  transition: 1s
.shift-home
  transform: translateX(300px)
  transition: 1s

#nav
  .icon-home
    display: none
    transition: linear 0.5s
    cursor: pointer
    width: 50px
    height: 50px
    position: fixed
    left: 30px
    top: 30px
    z-index: 1000
    filter: drop-shadow( 0px 0px 15px rgba(0, 0, 0, .3))
    .backText
      position: absolute
      color: black
      font-size: 24px
      font-weight: bold
      opacity: 0
      bottom: 0
      left: calc(95%)
      width: 100px
      transition: 1s
    &:hover .backText
      opacity: 1
      left: calc(100% + 20px)
      transition: 1s
    img
      width: 100%
  .navIcons-right
    position: fixed
    right: 30px
    top: 25px
    z-index: 1000
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
  .icon-menu
    cursor: pointer
    color: black
    position: fixed
    left: 30px
    top: 30px
  .icon-lang
    font-size: 40px
    cursor: pointer
    font-weight: 900
    z-index: 1000
    position: absolute
    right: -5px
    top: 0px
    color: black
    &.icon-white
      color: white
  .icon-white
    color: white
    svg
      fill: white
  #menu
    width: 100vw
    height: 100vh
    background-color: black
    position: fixed
    top: 0
    left: 0
    z-index: 999
    padding: 120px 0 80px 0
    overflow-x: hidden
    overflow-y: scroll
    transition-duration: 1s
    &.menu-full
      display: none !important
    &.menu-side
      position: fixed
      height: 100vh
      width: 30vw
      width: min(30vw, 300px)
      left: -30vw
      border-right: solid 20px rgba(0,0,0,0)
      top: 0
      transition-duration: 1s
      &.menu-side-open
        left: 0
    .menu-link
      width: 100vw
      // height: 100%
      height: calc( 60vh / 5)
      // max-height: calc( 60vh / 5)
      font-size: 64px
      font-size: min(4.6vmax, 100px)
      // font-size: 120px
      font-weight: bold
      color: white
      text-decoration: none
      position: relative
      background-color: black
      transition: transform 1s
      .dashed-border
        position: absolute
        bottom: 0
        width: 100%
        z-index: 668
      .menu-link-zh, .menu-link-en
        display: inline-block

      .menu-link-en
        margin-left: 20px
        // font-size: 54px
        font-size: 64px
        font-size: min(5vw, 112px)
        color: transparent
        -webkit-text-stroke: 2px white
        text-shadow: 3px 3px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000
      &:active
        .menu-link-en
          color: inherit
      &:before
        content: ''
        opacity: 0
        width: 50px
        height: 50px
        margin: 0px 20px
        border-radius: 100%
        background-color: #FF845F
        z-index: 5678
      &.left:hover
        color: #FF845F
        .menu-link-en
          -webkit-text-stroke: 2px #FF845F
        &:before
          opacity: 1
      &.right:hover
        color: #63C3CE
        .menu-link-en
          -webkit-text-stroke: 2px #63C3CE
        &:before
          opacity: 1
      &.right:before
        background-color: #63C3CE
#nav
  #menu
    &.menu-side
      background-color: rgba(0,0,0,0.95)
      // width: auto
      .menu-link
        background-color: rgba(0,0,0,0.0)
        width: 100%
        // border: rgba(255,255,255,0.95) solid 5px
        padding: 10px
        height: 13%
        min-height: 110px
        font-size: 24px
        font-size: min(2vw, 32px)
        img
          width: 100vw
        &:before
          display: none
          content: ''
          opacity: 0
          width: 25px
          height: 25px
          margin: 0px 20px
          border-radius: 100%
          background-color: #FF845F
        &.right:before
          background-color: #63C3CE
      .menu-link-zh
        margin-left: 15px
      .menu-link-en
        margin-left: 5px
        font-size: 24px
        font-size: min(2vw, 32px)
      // .filter-blur
      //   position: fixed
      //   top: 0
      //   left: 0
      //   width: 100vw
      //   height: 100vh
      //   filter: blur(5px)
      //   background-color: rgba(50,50,50,0.2)

@include for_breakpoint(mobile)
  #nav
    .icon-home
      display: initial
    .navIcons-right
      .icon-menu
        position: absolute
        left: initial
        right: 0px
        top: 0px
      .icon-lang
        top: 50px
        right: -5px
    #menu
      overflow-y: hidden
      &.menu-full
        display: initial !important
      &.menu-side
        display: none !important

  // #menu
  //   &.menu-full
  //     display: initial
  #nav .icon-home .backText
    display: none
  #nav #menu .menu-link
    &:active
      .menu-link-en
        color: transparent
    &.left:hover
      // color: #FF845F
      .menu-link-en
        -webkit-text-stroke: 2px rgba(255,255,255,0.3)
      &:before
        opacity: 1
    &.right:hover
      // color: #63C3CE
      .menu-link-en
        -webkit-text-stroke: 2px rgba(255,255,255,0.3)
    .icon-home
      font-size: 40px
    .menu-link-zh
      font-size: 2.5rem
      z-index: 1
      line-height: 1.2
    .menu-link-en
      font-size: 24px
      font-size: 4rem
      margin-left: 15px
      min-height: 120px
      position: absolute
      left: 0
      top: 0
      -webkit-text-stroke: 2px rgba(white,0.3)
      white-space: nowrap
      z-index: 0
      color: transparent

    .menu-link.active
      .menu-link-en
        -webkit-text-stroke: 2px rgba(white,0.3) !important

    &:before
      content: ''
      opacity: 0
      width: 30px
      height: 30px
      margin: 0px 15px
      border-radius: 100%
      padding: 15px
      background-color: #FF845F
      z-index: 5678

.menu-enter-active, .menu-leave-active
  transition: 0.5s
  opacity: 1
  img
    transition: 1s

  .left,.right
    position: relative
    transition: 0.6s cubic-bezier(0.25, 1, 0.5, 1)
    transition-delay: 1s
.menu-leave-active
  transition: 1s 0.2s
  img
    transition: 1s
  .left,.right
    transition: 3s cubic-bezier(0.64, 0, 0.78, 0)
    transition-delay: 2s
.menu-enter
  opacity: 0
  .left
    transform: translate(-20vmin)
    opacity: 0
  .right
    transform: translate(20vmin)
    opacity: 0
  .img
    transform: translate(20vmin)
.menu-leave-to
  opacity: 0
  .left
    transform: translate(200vmin)
    // opacity: 0
  .right
    transform: translate(-200vmin)
    // opacity: 0
</style>
